<template>
        <div class="page-nav" :class="{'mini-nav': miniNav}">
                <div class="nav-items">
                    <a href="#" class="nav-item">Terms of Use</a>
                    <a href="#" class="nav-item">Protected content</a>
                    <a href="#" class="nav-item">Price indications and other information</a>
                    <a href="#" class="nav-item">Cookies</a>
                    <a href="#" class="nav-item">What is an instructional price for electricity?</a>
                    <a href="#" class="nav-item">Avoid directions and save money</a>
                    <a href="#" class="nav-item">Compare electricity contracts and find the best agreement</a>
                </div>
            </div>
</template>

<script>
    export default {
        name: "pageNavigation",
        props:[
            'miniNav'
        ]
    }
</script>
